export default ({ store }) => {
  if (!store.getters['primaryFeeGroups/primaryFeeGroupsLoaded']) {
    return store.dispatch('primaryFeeGroups/loadPrimaryFeeGroups')
  }
}
